import { render } from "./Accessibility.vue?vue&type=template&id=c8356c10"
import script from "./Accessibility.vue?vue&type=script&lang=ts"
export * from "./Accessibility.vue?vue&type=script&lang=ts"

import "./Accessibility.vue?vue&type=style&index=0&id=c8356c10&lang=scss"
script.render = render

export default script